import { useMemo } from 'react';
/**
 * Hook that determines if the application is running within a native webview
 * by checking for the 'negotiatorapp' URL parameter
 * @returns Object containing isSupressed boolean flag
 * @public
 */
export const useSuppressOnNativeWebView = () => {
  const shouldSuppress = useMemo(() => {
    var _a;
    if (typeof window === 'undefined') return false;
    const params = new URLSearchParams((_a = window.location.search) === null || _a === void 0 ? void 0 : _a.toLowerCase());
    return params.get('negotiatorapp') === 'y';
  }, []);
  return {
    shouldSuppress
  };
};